/**
 * The behaviour table. One policy object per kind, looked up on spawn.
 *
 * Every walking thing here is a documented Backrooms entity except `hollow`,
 * which is a hallucination and says so. The table is an exhaustive
 * `Record<EntityKind, Behavior>` on purpose: a kind without a mind is a body
 * standing in a corridor doing nothing, and that should not compile.
 */

import type { EntityKind } from '../../core/types';
import type { Behavior } from '../brain';
import { bacteriaBehavior } from './bacteria';
import { centipedeBehavior } from './centipede';
import { clumpBehavior } from './clump';
import { deathmothBehavior } from './deathmoth';
import { facelingBehavior } from './faceling';
import { hollowBehavior } from './hollow';
import { houndBehavior } from './hound';
import { partygoerBehavior } from './partygoer';
import { smilerBehavior } from './smiler';

const BEHAVIORS: Record<EntityKind, Behavior> = {
  // Entity 8. The dog.
  hound: houndBehavior,
  // Entity 3.
  smiler: smilerBehavior,
  // Entity 5.
  clump: clumpBehavior,
  // Level 0's own, from the Kane Pixels canon.
  bacteria: bacteriaBehavior,
  // Entity 9, the Shadow variant. The one that only moves when you look away.
  faceling: facelingBehavior,
  // Entity 4.
  deathmoth: deathmothBehavior,
  // Entity 67.
  partygoer: partygoerBehavior,
  // The Sticky-Centipede.
  centipede: centipedeBehavior,
  // Not an entity: what a failing mind puts at the end of a corridor.
  hollow: hollowBehavior,
};

export function getBehavior(kind: EntityKind): Behavior {
  return BEHAVIORS[kind];
}
